// extracted by mini-css-extract-plugin
export default {"title":"ProjectManagement_title__CpKs8"};